import imgMobile from '../../assets/premium/img-baner-premium-small.png'
import img from '../../assets/premium/img-baner-premium-small.png'
import styled, { ITheme } from '../../theme'
import { IWithSize } from '../../containers/BookingCalendar/Calendar/Calendar'

const Bar = styled.div<IWithSize>`
 
 background: white url("${imgMobile}") no-repeat 0 0;
 height: ${({ size }) => (size ? 80 * size : 80)}px;
 width: ${({ size }) => (size ? 950 * size : 950)}px;
  background-position-x: calc(90vw - 97vw);
 	background-position-y: -107px;
 	
  @media (min-width: ${(props: ITheme) => props.theme.breakpoints.tablet}) {
 	height: ${({ size }) => (size ? 120 * size : 120)}px;
 	background: white url("${img}") no-repeat;
 	background-position-x: calc(100vw - 95vw);
 	background-position-y: -107px;
 }

`

export default Bar
